
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","viewBox":"0 0 24 24","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.5 24h-13A2.502 2.502 0 013 21.5v-19C3 1.121 4.121 0 5.5 0h13C19.879 0 21 1.121 21 2.5v19c0 1.379-1.121 2.5-2.5 2.5zM5.5 1C4.673 1 4 1.673 4 2.5v19c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5v-19c0-.827-.673-1.5-1.5-1.5z"}}),_c('path',{attrs:{"d":"M9 12H6.5a.5.5 0 010-1H9a1 1 0 000-2H8c-1.103 0-2-.897-2-2s.897-2 2-2h2.5a.5.5 0 010 1H8a1 1 0 000 2h1c1.103 0 2 .897 2 2s-.897 2-2 2z"}}),_c('path',{attrs:{"d":"M8.5 13.5A.5.5 0 018 13v-1.5a.5.5 0 011 0V13a.5.5 0 01-.5.5zM8.5 6a.5.5 0 01-.5-.5V4a.5.5 0 011 0v1.5a.5.5 0 01-.5.5zM17.5 21h-11a.5.5 0 010-1h11a.5.5 0 010 1zM17.5 17h-11a.5.5 0 010-1h11a.5.5 0 010 1zM17.5 13h-4a.5.5 0 010-1h4a.5.5 0 010 1zM17.5 9h-4a.5.5 0 010-1h4a.5.5 0 010 1z"}})])
          )
        }
      }
    